/* eslint-disable @next/next/no-img-element */
// js
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
// utils
import { sha256 } from 'js-sha256';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { FaWhatsapp, FaWindowClose } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import { sendUser } from '../../../services/properties';
import { useSiteRegiao } from '../../context/Info';
import { trackEvent } from '../../../utils/FunctionsGlobals';
import { trackMetaEvent, genMetaEventId, resolvePixelId, sendMetaCapiEvent, metaPrecoParams } from '../../../utils/metaPixel';
import { resolveSite2524WhatsAppUrl } from '../../../utils/site2524WhatsApp';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import { getFloatingWhatsHref } from '../../../utils/floatingWhatsHref';
import { whatsParaImobiliaria } from '../../../utils/whatsappImobiliaria';
import ChannelChatWidget from '../channelChat/ChannelChatWidget';
import IconeWhatsappFlutuante from './IconeWhatsappFlutuante';
import { whatsFlutuanteSempre } from '../../../utils/whatsFlutuanteSempre';
import { whatsFormularioPrimeiro } from '../../../utils/whatsFormularioPrimeiro';
import { siteUsaFormularioExternoNoWhats } from '../../../utils/formularioExternoNoWhats';
import { ehWhatsComDestinatario } from '../../../utils/urlPaginaNoWhats';
import styles from './WhatsappComponent.module.css';
import { temTelefonePorOperacao, telefoneOperacao, rotuloOperacao, menuOperacaoDisponivel } from '../../../utils/telefoneOperacao';

const AppPhoneInput = dynamic<any>(
    () => import('../../input_phone/AppPhoneInput').then((mod) => mod.AppPhoneInput as any),
    { ssr: false }
);

// ── Evento EXCLUSIVO do formulário do WhatsApp FLUTUANTE ───────────────────────────────────
// O widget flutuante disparava os MESMOS eventos do formulário da ficha do imóvel
// (`generate_lead`/`lead_submit_success` no GA/GTM e `Lead` com lead_source
// 'property_contact_form' na Meta quando renderizado dentro da ficha) — as duas origens ficavam
// misturadas na mensuração. Agora o formulário do flutuante tem nome PRÓPRIO, disparado só no
// ENVIO concluído (lead gravado), nunca no simples clique no ícone do WhatsApp.
// Mesmo nome nas duas ferramentas (GA4/GTM e Meta) p/ o cliente achar a conversão pelo mesmo termo.
// ⚠️ O nome também está na allowlist de `pages/api/meta-capi.ts` (ALLOWED_EVENTS).
export const FLOATING_WHATSAPP_LEAD_EVENT = 'whatsapp_flutuante_lead';
// Rótulo de origem (param `lead_source` da Meta / `source` do GA) — identifica o widget.
export const FLOATING_WHATSAPP_LEAD_SOURCE = 'whatsapp_flutuante';

const WhatsAppComponent: React.FC<{ site: any, origin?: string, codsite?: number, agenciador?: any, id_imovel?: any, open?: any, setOpen?: any, lead?: any, visita?: Boolean, managerActual?: any,delegar_ao_agenciador?: any, detailsProperties?: any}> = ({ site: siteProp, origin, codsite, agenciador, id_imovel, open, setOpen, lead, visita, managerActual, delegar_ao_agenciador, detailsProperties }) => {
    // MULTI-REGIÃO: contatos (tel1/tel2/email1) trocados pelos da região ativa quando houver
    const site = useSiteRegiao(siteProp);
    // #843 cs2451: override do FAB flutuante — não-nulo só p/ o site.id '2451' (Tintim); demais sites = null.
    const floatingWhatsHref = getFloatingWhatsHref(site);
    const [buttons, setButtons] = useState(0);
    const [formOpen, setFormOpen] = useState(0);
    const [formFOpen, setFormFOpen] = useState(0);
    const router = useRouter();
    const [horaAtual, setHoraAtual] = useState('');
    const [nome, setNome] = useState(lead?.nome ? lead?.nome : '');
    const [email, setEmail] = useState(lead?.email ? lead?.email :'');
    const [telefone, setTelefone] = useState(lead?.telefone ? lead?.telefone :'');
    const [processando, setProcessando] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const [texto, setTexto] = useState<any>();

    const renderText = (transacao?: any) => {
        if(id_imovel){
            if(visita){
                return `Olá, quero agendar uma visita ao imóvel: Link: https://${site?.site}/imovel/${id_imovel}`;
            }
            return `Olá, vi este imóvel no site. Link: https://${site?.site}/imovel/${id_imovel} você pode me dar mais informações?`;
        }
        if (site?.id) {
            if(site?.texto_botao_whats){
                return `${site?.texto_botao_whats}`;
            }
            if(site?.id == "2027"){
                if(transacao == "venda"){
                    return "Olá, estou visitando o site e gostaria de informações sobre vendas. Pode me ajudar?";
                } else {
                    return "Olá, estou visitando o site e gostaria de informações sobre locação. Pode me ajudar?";
                }
            }
            return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
        }
        return '';
    };

    useEffect(() => {
        const renderText1 = () => {
            if(id_imovel){
                if(visita){
                    return `Olá, quero agendar uma visita ao imóvel: Link: https://${site?.site}/imovel/${id_imovel}`;
                }
                return `Olá, vi este imóvel no site. Link: https://${site?.site}/imovel/${id_imovel} você pode me dar mais informações?`;
            }
            if (site?.id) {
                if(site?.texto_botao_whats){
                    return `${site?.texto_botao_whats}`;
                }
                return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
            }
            return '';
        };

        setTexto(renderText1())
    }, [site, router, id_imovel, visita]);

    useEffect(() => {
        if(lead?.nome){
            setNome(lead?.nome)
        }
        if(lead?.email){
            setEmail(lead?.email)
        }
        if(lead?.telefone){
            setTelefone(lead?.telefone)
        }
    }, [lead]);

    useEffect(() => {
        const dataAtual = new Date();
        const hora = dataAtual.getHours();
        const minuto = dataAtual.getMinutes();
        const horaFormatada = `${hora}:${minuto < 10 ? '0' : ''}${minuto}`;
        setHoraAtual(horaFormatada);
    }, []);

    const handleChange = (event: any) => {
      setTexto(event.target.value);
    };

    const openButtons = () => {
        trackMetaEvent(site, 'Contact', {
            content_name: 'WhatsApp flutuante',
            contact_method: 'whatsapp',
            content_category: 'floating_button',
        });
        setButtons(1);
    };

    const closeButtons = () => {
        setButtons(0);
    };

    const openButtonsForm = () => {
        setFormOpen(1);
    };

    const closeButtonsForm = () => {
        setFormOpen(0);
        if(setOpen){
            setOpen(false)
        }
    };

    const openForm = () => {
        setFormFOpen(1);
    };

    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setNome(value);
    };

    const onChangeTelephone = (value: string) => {
        setTelefone(value);
    };

    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    const phoneDigits = telefone?.replace(/\D/g, '') || '';
    const phoneLengthValid = phoneDigits.length > 9 && phoneDigits.length < 17;
    const emailValid = /\S+@\S+\.\S+/.test(email);
    const canSend = nome != '' && email != '' && telefone != '' && phoneLengthValid && emailValid && !processando;
    const isSite1791 = Number(site?.id) === 1791;
    const isSite2537 = Number(site?.id) === 2537;
    const hasVenda = Number(detailsProperties?.venda) > 0 || detailsProperties?.venda === true;
    const hasAluguel = Number(detailsProperties?.aluguel) > 0 || detailsProperties?.aluguel === true;
    const transactionPhoneType: 'venda' | 'locacao' = hasAluguel && !hasVenda ? 'locacao' : 'venda';

    const cleanPhone = (phone?: string) => (phone || '').replace(/\D/g, '');
    const resolveWhatsappPhone = (
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = transactionPhoneType
    ) => {
        if (isSite1791) {
            if (transaction === 'locacao' && hasAluguel && !hasVenda) {
                return '555184010353';
            }
            return '5551984012364';
        }
        // SD-0049 (gate cs2532): número por operação vindo do cadastro (tel1 venda / tel3 locação)
        if (temTelefonePorOperacao(site)) {
            return cleanPhone(telefoneOperacao(site, transaction));
        }
        return cleanPhone(fallbackPhone);
    };
    const buildWhatsappUrl = (
        message: string,
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = transactionPhoneType
    ) => {
        const phone = resolveWhatsappPhone(fallbackPhone, transaction);
        if (!phone) return '#';

        const prefix = isSite1791 || managerActual?.internacional ? '' : '55';
        return resolveSite2524WhatsAppUrl(site, `https://api.whatsapp.com/send?phone=${prefix}${phone}&text=${message}`);
    };
    const defaultSitePhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel1 || site?.Dados?.tel2
        : site?.Dados?.tel1 || site?.Dados?.tel2;
    const defaultManagerPhone =
        managerActual?.telefone ||
        managerActual?.telefone_2 ||
        defaultSitePhone;
    const defaultVendaPhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel2 || site?.Dados?.tel1
        : site?.Dados?.tel2 || site?.Dados?.tel1;
    const defaultAnyPhone =
        managerActual?.telefone ||
        managerActual?.telefone_2 ||
        defaultSitePhone ||
        site?.Dados?.tel3 ||
        site?.Dados?.tel4;
    const whatsappLocacaoUrl = whatsParaImobiliaria(buildWhatsappUrl(
        renderText("locacao"),
        defaultManagerPhone,
        'locacao'
    ), site, managerActual?.telefone || managerActual?.telefone_2 ? managerActual : null, 'I');
    const whatsappVendaUrl = whatsParaImobiliaria(buildWhatsappUrl(
        renderText("venda"),
        managerActual?.telefone || managerActual?.telefone_2 || defaultVendaPhone,
        'venda'
    ), site, managerActual?.telefone || managerActual?.telefone_2 ? managerActual : null, 'I');
    const whatsappVendaUrl2 = whatsParaImobiliaria(buildWhatsappUrl(
        renderText("venda"),
        managerActual?.telefone || managerActual?.telefone_3 || defaultVendaPhone,
        'venda'
    ), site, managerActual?.telefone || managerActual?.telefone_3 ? managerActual : null, 'I');
    const whatsappTextoUrl = whatsParaImobiliaria(buildWhatsappUrl(
        encodeURIComponent(texto),
        defaultManagerPhone,
        transactionPhoneType
    ), site, managerActual?.telefone || managerActual?.telefone_2 ? managerActual : null, 'I');
    const whatsappDefaultUrl = whatsParaImobiliaria(buildWhatsappUrl(
        renderText(),
        defaultAnyPhone,
        transactionPhoneType
    ), site, managerActual?.telefone || managerActual?.telefone_2 ? managerActual : null, 'I');

    // cs2431: o formulário antes do WhatsApp é o EXTERNO (utils/formularioExternoNoWhats.ts) e
    // vale para todos os botões — o próprio do flutuante sai de cena e o ícone vira link comum.
    const formularioExterno = siteUsaFormularioExternoNoWhats(site);

    // Quem monta este componente já com open=true (o placeholder da home) estava pedindo o
    // formulário próprio. Aqui o pedido vira "ir para o WhatsApp": o interceptador
    // (components/fixed/formularioExternoNoWhats) segura este window.open e abre o modal.
    useEffect(() => {
        if (!formularioExterno || !open) return;
        if (setOpen) setOpen(false);
        if (ehWhatsComDestinatario(whatsappDefaultUrl)) window.open(whatsappDefaultUrl, '_blank');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formularioExterno, open]);

    const validaSendUser = async () => {
        if (nome != '' && email != '' && telefone != '') {
            const phone = telefone.replace(/[^0-9]/g, '');
            const verifica = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && verifica) {
                if (re.test(email) == true) {
                    if(!processando){
                        setProcessando(true);
                        actionSendUser();
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para enviar sua mensagem!'
            );
        }
    };

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
      }

    function horaAtual1() {
        const dataAtual = new Date();
        const hora = dataAtual.getHours();
        const minuto = dataAtual.getMinutes();
        const horaFormatada = `${hora}:${minuto < 10 ? '0' : ''}${minuto}`;
        return horaFormatada
    }

    const actionSendUser = async () => {
        const getSendUser = await sendUser(
            site?.internacional ? true : false,
            "",
            "",
            "",
            "",
            JSON.stringify(texto),
            JSON.stringify(nome),
            JSON.stringify(email),
            JSON.stringify(telefone),
            id_imovel ? id_imovel : 0,
            agenciador && delegar_ao_agenciador ? agenciador : 0,
            origin || "",
            codsite || 0,
            "",
            delegar_ao_agenciador ? 1 : 0
        );

        if(getSendUser?.atendimento?.id_cliente){
            const user = {
                nome,
                telefone,
                email,
            };

            localStorage.setItem('user', JSON.stringify(user));

            // Dedup browser×CAPI da Meta é por (event_name + event_id) → CADA evento leva o seu id.
            const leadEventId = genMetaEventId();
            const floatingLeadEventId = genMetaEventId();

            // O formulário do flutuante SEMPRE se identifica como `whatsapp_flutuante` — inclusive
            // quando o widget é renderizado DENTRO da ficha do imóvel (lá ele recebe `id_imovel` e
            // antes mandava lead_source='property_contact_form', ficando INDISTINGUÍVEL do
            // formulário da própria ficha). O conteúdo do imóvel continua indo quando existe.
            const metaLeadData: Record<string, any> = id_imovel ? {
                content_ids: [String(id_imovel)],
                content_type: 'product',
                content_name: detailsProperties?.titulo,
                lead_source: FLOATING_WHATSAPP_LEAD_SOURCE,
                ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
            } : {
                lead_source: FLOATING_WHATSAPP_LEAD_SOURCE,
            };

            // Lead de BROWSER (Pixel) — evento PADRÃO da Meta, mantido para não quebrar a
            // otimização de campanha de quem já usa `Lead` como conversão. No-op p/ tenant sem pixel.
            trackMetaEvent(site, 'Lead', metaLeadData, { eventId: leadEventId });

            // Evento CUSTOMIZADO EXCLUSIVO do formulário do flutuante (fbq trackCustom) — é ele que
            // permite separar, no Gerenciador da Meta, o lead do widget do lead do form da ficha.
            trackMetaEvent(site, FLOATING_WHATSAPP_LEAD_EVENT, metaLeadData, {
                eventId: floatingLeadEventId,
                custom: true,
            });

            if (site?.tag_google_head || site?.google_analytics_head) {
                    const eventData = {
                    source: FLOATING_WHATSAPP_LEAD_SOURCE,
                    client_id: getSendUser?.atendimento?.id_cliente,
                    property_id: id_imovel || undefined,
                    lead_name: nome,
                    lead_email: email,
                    lead_phone: telefone,
                    // ⚠️ evite enviar PII (nome, email, telefone) para GA/GA4 (o trackEvent poda)
                };

                // GA4/GTM: SÓ o evento exclusivo do flutuante. `generate_lead`/`lead_submit_success`
                // NÃO saem mais daqui — ficaram sendo exclusivos dos formulários das páginas
                // (ficha do imóvel, blog, condomínios), que é o que o cliente mede como lead da página.
                trackEvent(FLOATING_WHATSAPP_LEAD_EVENT, eventData);
            }

            // Pernas CAPI (server-side /api/meta-capi): PII hasheada no CLIENTE; cada uma com o MESMO
            // eventId da sua perna browser → a Meta dedupa. Token/pixel resolvidos por host no servidor.
            if (resolvePixelId(site?.fb_id_pixel, site?.pixel_facebook_head)) {
                const normalizedName = nome.trim().toLowerCase();
                const normalizedEmail = email.trim().toLowerCase();
                const normalizedPhone = telefone.replace(/\D/g, ''); // Apenas números

                const userData = {
                    fn: [sha256(normalizedName)],
                    em: [sha256(normalizedEmail)],
                    ph: [sha256(normalizedPhone)],
                };

                // ESPELHA os params não-PII das pernas browser acima: com adblocker o /tr morre
                // e só este endpoint first-party chega — sem custom_data perderíamos value/conteúdo.
                sendMetaCapiEvent({
                    site,
                    eventName: 'Lead',
                    eventId: leadEventId,
                    customData: metaLeadData,
                    userData,
                });

                sendMetaCapiEvent({
                    site,
                    eventName: FLOATING_WHATSAPP_LEAD_EVENT,
                    eventId: floatingLeadEventId,
                    customData: metaLeadData,
                    userData,
                });
            }
        }

        setFormFOpen(0)
        setFormOpen(0)
        setEnviado(true)
        setProcessando(false);
        if(setOpen){
            setOpen(false)
        }
    };

    const renderFloatingWhatsappIcon = () => (
        <IconeWhatsappFlutuante
            className={site?.id == 1874 || site?.id == 2355 ? styles.svg_whats1 : styles.svg_whats}
            verde={site?.id == 2470 ? "#928f88" : "#20b038"}
        />
    );

    const quickWhatsappActions = [
        site?.id == 2473
            ? {
                key: 'terceiro',
                href: whatsappVendaUrl2,
                label: site?.Dados?.tel3_nome || 'Atendimento 3'
            }
            : null,
        {
            key: 'locacao',
            href: whatsappLocacaoUrl,
            label: temTelefonePorOperacao(site)
                ? rotuloOperacao(site, 'locacao')
                : (managerActual?.nome ||
                    site?.Dados?.tel1_nome ||
                    managerActual?.telefone ||
                    managerActual?.telefone_2 ||
                    'Locacao')
        },
        {
            key: 'venda',
            href: whatsappVendaUrl,
            label: temTelefonePorOperacao(site) ? rotuloOperacao(site, 'venda') : (site?.Dados?.tel2_nome || 'Venda')
        }
    ].filter(
        (item): item is { key: string; href: string; label: string } =>
            Boolean(item?.href && item.href !== '#' && item.label)
    );

    return (
        floatingWhatsHref ? (
            <div className={whatsFlutuanteSempre(site) ? `${styles.logo_whatsapp} ${styles.sempreVisivel}` : styles.logo_whatsapp}>
                <a
                    className={styles.logo_button}
                    href={floatingWhatsHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Abrir atendimento no WhatsApp"
                    onClick={() => trackLead(site, {})}
                >
                    {renderFloatingWhatsappIcon()}
                </a>
            </div>
        ) : site?.id != "105" && site?.id != "664" && site?.id != "2245" ?
            <>
            {Number(site?.id) === 2439 ? <ChannelChatWidget /> : null}
            <div className={site?.id == "1893" ? styles.logo_whatsapp2 : whatsFlutuanteSempre(site) ? `${styles.logo_whatsapp} ${styles.sempreVisivel}` : styles.logo_whatsapp}>
                { ((site?.transacoes?.length == 2 && site?.Dados?.tel1_whats && site?.Dados?.tel2_whats && site?.Dados?.tel1_nome && site?.Dados?.tel2_nome && site?.id != "1722") || (site?.transacoes?.length == 2 && menuOperacaoDisponivel(site))) && !whatsFormularioPrimeiro(site, codsite) ?
                    <>
                        { !buttons && !open ?
                            <div className={styles.logo_button} onClick={() => openButtons()}>
                                {renderFloatingWhatsappIcon()}
                            </div>
                        :
                        <div className={site?.id == "1893" ? styles.venda_menu_alt : styles.venda_menu}>
                            {quickWhatsappActions.map((action) => (
                                <a
                                    key={action.key}
                                    className={styles.venda}
                                    onClick={() => {closeButtons();trackLead(site, {});}}
                                    href={action.href}
                                    data-no-quicklink
                                    data-no-instant
                                    data-no-prefetch
                                    rel="nofollow"
                                >
                                    {action.label}
                                </a>
                            ))}
                        </div> }
                    </>
                    :
                    site?.formulario_whats && !formularioExterno ?
                    <>
                        { !formOpen && !open ?
                            <div className={styles.logo_button} onClick={() => openButtonsForm()} title="Atendimento Personalizado" data-gtm-text="Atendimento Personalizado">
                                {renderFloatingWhatsappIcon()}
                            </div>
                        :
                        !formFOpen ?
                            <>
                                <div className={styles.card_form}>
                                    <div className={styles.card_head}>
                                        <span className={styles.header_header}>
                                            <div className={styles.whats_header}><FaWhatsapp size={25}/></div>
                                            <div className={styles.whats_header}><p>{site?.titulo}</p></div>
                                        </span>
                                        <div className={styles.whats_header}><FaWindowClose className={styles.button_exit} size={25} onClick={() => closeButtonsForm()} cursor={"pointer"}/></div>
                                    </div>
                                    <div className={styles.card_menssage}>
                                        <p className={styles.mensagem_whats}>Olá <span>{horaAtual}</span></p>
                                        <p className={styles.mensagem_whats}>Está precisando de ajuda? <span>{horaAtual}</span></p>
                                        <p className={styles.mensagem_whats}>Entre em contato via WhatsApp <span>{horaAtual}</span></p>
                                        {enviado ?
                                            <>
                                                <p className={styles.mensagem_whats_reposta}>{texto}<span>{horaAtual1()}</span></p>
                                                {site?.id != "1784" && site?.id != "1722" ?
                                                    <p className={styles.mensagem_whats}>Por favor conclua o envio da mensagem no WhatsApp e assim que possível vamos retornar o contato.<span>{horaAtual1()}</span></p>
                                                :
                                                    <p className={styles.mensagem_whats}>Recebemos sua mensagem, assim que possível vamos retornar seu contato.<span>{horaAtual1()}</span></p>
                                                }
                                                {site?.id == "1784" || site?.id == "1722" ?
                                                    null
                                                :
                                                <div className={styles.card_send}>
                                                    <a
                                                        className={styles.button_more_photo}
                                                        href={whatsappTextoUrl}
                                                        onClick={async (e) => {
                                                            e.preventDefault(); // Evita o redirecionamento automático

                                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                            setTimeout(() => {
                                                                window.open(whatsappTextoUrl,
                                                                "_blank"
                                                              );
                                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                          }}
                                                        rel="noreferrer"
                                                    >
                                                        Enviar Mensagem
                                                    </a>
                                                </div>
                                                }
                                            </>
                                        : null}
                                    </div>
                                    {!enviado ?
                                        <div className={styles.card_send}>
                                            <div className={styles.mensagem_send}>
                                                <textarea
                                                    value={texto} // Define o valor do textarea como o valor do estado "texto"
                                                    onChange={handleChange} // Configura a função de manipulação de mudanças
                                                    className={styles.text_area_send}
                                                ></textarea>
                                            </div>
                                            <div className={styles.enviar_send}>
                                                <IoMdSend size={30} onClick={() => openForm()}/>
                                            </div>
                                        </div>
                                    : null}
                                </div>
                            </>
                        :
                            <>
                            <div className={styles.card_formF}>
                                <div className={styles.card_head}>
                                    <span className={styles.header_header}>
                                        <div className={styles.whats_header}><FaWhatsapp size={25}/></div>
                                        <div className={styles.whats_header}><p>{site?.titulo}</p></div>
                                    </span>
                                    <div className={styles.whats_header}><FaWindowClose className={styles.button_exit} size={25} onClick={() => closeButtonsForm()}/></div>
                                </div>
                                <div className={styles.card_menssage_form}>
                                    <div className={styles.form}>
                                        <input
                                            className={styles.input}
                                            placeholder="Nome"
                                            value={nome}
                                            onChange={onChangeName}
                                        />
                                        <AppPhoneInput
                                            id="Telefone_id"
                                            value={telefone}
                                            onChange={onChangeTelephone}
                                            placeholder="Telefone"
                                            defaultCountry="BR"
                                            width_max={90}
                                            inputHeight={40}
                                            limitMaxLength={true}
                                            inputClassName={styles.input}
                                            semPais={!site?.internacional ? true : false}
                                            includeCountryCode={site?.internacional ? true : false}
                                        />
                                        <input
                                            className={styles.input}
                                            placeholder="Email"
                                            value={email}
                                            onChange={onChangeEmail}
                                        />
                                        <div className={styles.adjust_checkbox}>
                                            <div className={styles.description_form}>
                                                Ao enviar concordo com os
                                                <Link prefetch={false} href="/termos">
                                                    <div className={styles.terms}>
                                                        termos de uso
                                                    </div>
                                                </Link>
                                                e
                                                <Link prefetch={false} href="/politica">
                                                    <div className={styles.terms}>
                                                        política de privacidade
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        {!canSend ?
                                            <div
                                                className={
                                                    canSend ? styles.button_more_photo : styles.action_disabled
                                                }
                                                onClick={validaSendUser}
                                            >
                                                Enviar Mensagem
                                            </div> :
                                            <a
                                                className={
                                                    canSend ? styles.button_more_photo : styles.action_disabled
                                                }
                                                href={whatsappTextoUrl}
                                                onClick={async (e) => {
                                                    e.preventDefault(); // Evita o redirecionamento automático

                                                    await validaSendUser(); // 🔥 Aguarda a validação antes de continuar

                                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                    setTimeout(() => {
                                                    window.open(whatsappTextoUrl,
                                                        "_blank"
                                                    );
                                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                }}
                                                rel="noreferrer"
                                            >
                                                Enviar Mensagem
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        }
                    </>
                    :
                    <a
                        rel="noopener noreferrer"
                        href={whatsappDefaultUrl}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático

                            trackLead(site, null); // 🔥 Registra o evento Lead

                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                              window.open(
                                whatsappDefaultUrl,
                                "_blank"
                              );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                          }}
                        title='Clique para conversar pelo WhatsApp'
                        className={styles.logo_button}
                    >
                        {renderFloatingWhatsappIcon()}
                    </a>
                }
            </div>
            </>
        : null
    );
};

export default WhatsAppComponent;
